'use strict';

exports.__esModule = true;
exports.getUrlParam = getUrlParam;
exports.random = random;
exports.fixCid = fixCid;
var baseUrl = '//eventsapi.gm99.com/activity/execute?name=bsjyy&action=';
var exchangeBaseUrl = '//eventsapi.gm99.com/activity/execute?name=bsjyy_charge_point&action=';
var config = exports.config = {
    url: {
        getLoginStatus: '//passport.gm99.com/ajax/get_user_json',
        login: '//passport.gm99.com/?forward=' + encodeURIComponent(window.location.href) + '&device=' + (window.isPhone ? 2 : 1) + '&cid=' + getUrlParam('cid') + '&scid=' + getUrlParam('scid'),
        getVerifyCode: baseUrl + 'check_phone',
        getBookingInfo: baseUrl + 'get_base_info',
        doBooking: baseUrl + 'do_reserve',
        getGifts: exchangeBaseUrl + 'get_gift',
        getParam: exchangeBaseUrl + 'get_param',
        share: exchangeBaseUrl + 'share'
    }
};
function getUrlParam(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var result = window.location.search.substr(1).match(reg);
    return result ? decodeURIComponent(result[2]) : null;
}
var validate = exports.validate = {
    isPhoneNumber: function isPhoneNumber(country, value) {
        switch (country) {
            case '大陸':
                return (/^1\d{10}$/.test(value)
                );
            case '香港':
                return (/^\d{8}$/.test(value)
                );
            case '台灣':
                return (/^\d{10}$/.test(value)
                );
            case '澳門':
                return (/^\d{8}$/.test(value)
                );
            case '馬來西亞':
                return (/^0\d{9}$/.test(value) || /^0\d{10}$/.test(value) || /^[1-9]\d{8}$/.test(value) || /^[1-9]\d{9}$/.test(value)
                );
        }
    }
};

function random(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}

function fixCid() {
    var url = location.href;

    if (url.indexOf('&cid=') === -1 && url.indexOf('?cid=') === -1) {
        if (url.indexOf('?') === -1) {
            window.location.href = url + '?cid=0';
        } else {
            if (!url[url.indexOf('?') + 1]) {
                url = url.replace('?', '');
                window.location.href = url + '?cid=0';
            } else {
                if (!url[url.lastIndexOf('&') + 1]) {
                    window.location.href = url + 'cid=0';
                } else {
                    window.location.href = url + '&cid=0';
                }
            }
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/util/util.js
// module id = 22
// module chunks = 7 8